<template>
  <div class="EditPresentation">

    <presentation-breadcrumbs :items="[{text: 'Edit'}]">
    </presentation-breadcrumbs>

    <presentation-toolbar :presentation="presentation">
    </presentation-toolbar>

  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import presentationService from '../../../../ml/services/presentationService';
import PresentationBreadcrumbs from "./components/PresentationBreadcrumbs";
import PresentationToolbar from "./components/PresentationToolbar";

export default {
  components: {PresentationToolbar, PresentationBreadcrumbs},
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: new Form(presentationService.presentationFormFields())
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ])
  },
  created() {
    presentationService.populateForm(this.form, this.presentation, this.user)
  }
}
</script>
